(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/syndicate-helpers.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/syndicate-helpers.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.syndicate = svs.syndicate || {};
  svs.syndicate.core = svs.syndicate.core || {};

  svs.syndicate.core.isCurrentMemberOwner = function(member) {
    if (member) {
      return member.isOwner();
    }
    return false;

  };

  svs.syndicate.core.isCurrentMemberActive = function(member) {
    if (member) {
      return member.active();
    }
    return false;
  };
})(Backbone, _, svs);


 })(window);